import React, { Component } from 'react'
import RefSelect from './RefSelect';

import { getCostCentres } from '../api/resources/CostCentres'

export default class CostCentreSelect extends Component {

  constructor(props) {
    super(props)
    this.state = { costCentres: [] }
  }

  componentDidMount() {
    getCostCentres().then(costCentres => this.setState({ costCentres }) )
  }

  render() {

    const { initialValue, onUpdate, error } = this.props;
    const { costCentres } = this.state;

    return costCentres ?
      <RefSelect
        options={costCentres}
        initialValue={initialValue}
        onUpdate={onUpdate}
        error={error}
        label='Cost centre'
      /> : null
    
  }
}